export const MAP_TILES = {
  GOOGLE: 'google',
  IGN: 'ign',
  NONE: 'none',
} as const;

export const IGN_MAX_ZOOM = 19;
export const GOOGLE_MAX_ZOOM = 20;
